module.exports = __webpack_public_path__ + "img/3.222fd59a.jpg";